import lazyLoad from 'utils/lazyLoad'

export default lazyLoad(() => import('./StandardConsentMessage'))
